module.exports = __webpack_public_path__ + "img/VentasIngresos.78a09894.svg";